import LoginGameStep from '../game_steps/login_gamestep';
import RestrictionsGameStep from '../game_steps/restrictions_gamestep';
import GameSequenceInitializerBase from './game_sequence_initializer_base';
import BuildGamePostMessageHandlerGameStep from '../game_steps/build_game_post_message_handler_gamestep';
import RealityCheckIntervalAppenderGameStep from '../game_steps/reality_check_interval_appender_gamestep';
import GameSequenceBuilder from '../game_sequence_builder/game_sequence_builder';

export default class RealGameSequenceInitializer extends GameSequenceInitializerBase {
    static CLASS = 'RealGameSequenceInitializer';

    initSequenceBuilder(): GameSequenceBuilder {
        let gameSequenceBuilder: GameSequenceBuilder = this._createSequenceBuilder();
        let builder: GameSequenceBuilder = gameSequenceBuilder.insert(LoginGameStep).last()
                                  .insert(RestrictionsGameStep, {isReal: true}).last()
                                  .insert(BuildGamePostMessageHandlerGameStep, {isReal: true}).last()
                                  .insert(RealityCheckIntervalAppenderGameStep).last();

        return builder;
    }
}
